/*
 * Auth AD Interceptor
 * This interceptor attaches Azure AD access token to protected resources
 * specified in ./src/app/root.module.ts under the name protectedResourceMap
 * Note: This interceptor will not add tokens to WSO2 Token APIs. Refer wso-apim.interceptor for the same
 */

import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PopupService } from '../modules/popup/services/popup.service';
import { AuthService } from '@shared/services/auth.service';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthAdInterceptor implements HttpInterceptor {
  private readonly baseURLConfig: any;
  private readonly APIMConfig: any;
  private readonly authConfig: any;
  constructor(
    private popupService: PopupService,
    private authService: AuthService,
    private runTimeConfigService: RunTimeConfigService,
    private oauthService: OAuthService
  ) {
    this.baseURLConfig = this.runTimeConfigService.getConfig('baseURLConfig');
    this.APIMConfig = this.runTimeConfigService.getConfig('APIMConfig');
    this.authConfig = this.runTimeConfigService.getConfig('authConfig');
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const APIMAuthURLs = [
      this.baseURLConfig.APIM.baseURL + this.APIMConfig.getAccessToken.endPoint,
      this.baseURLConfig.APIM.baseURL + this.APIMConfig.revokeAccessToken.endPoint
    ];
    if (APIMAuthURLs.includes(req.url)) {
      return next.handle(req);
    }

    const accessTokenAD = this.oauthService.getAccessToken();
    const authHeader = 'Bearer ' + accessTokenAD;
    if (!accessTokenAD) {
      return next.handle(req);
    }
    const authReq = req.clone({
      setHeaders: {
        Authorization: authHeader
      }
    });
    return next.handle(authReq);
  }
}
